import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams, AlertController, ToastController } from 'ionic-angular';
import { Globals } from "../../../../globals";
import { DishServices } from "../../services";
import { Uploads } from "../../../services/uploads";
import { IngredientsServices } from '../../../ingredients/services';
import { PrintServices } from '../../../services/printServices';
import { StaticsServices } from '../../../services/statics';
import { CurrencyPipe, getCurrencySymbol } from '@angular/common';
import { ConfigurationServices } from '../../../configuration/services';
import * as moment from 'moment';
import { ProviderOrderAddPage } from '../../../providers/orders/provider-order-add/provider-order-add';
import { TranslateService } from '@ngx-translate/core';
import { VariationsCreateFavSelectPage } from '../../../variations/variations-create-fav-select/variations-create-fav-select';
import { DishViewLabelPage } from '../dish-view-label/dish-view-label';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AddonsTriggerVersionProPage } from '../../../addons/addons-trigger-version-pro/addons-trigger-version-pro';
import { IngredientViewPage } from '../../../ingredients/ingredient-view/ingredient-view/ingredient-view';
import { DishCreatePricePage } from '../../dish-create/dish-create-price/dish-create-price';

/**
 * Generated class for the DishViewPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
    selector: 'page-dish-view',
    templateUrl: 'dish-view.html',
})
export class DishViewPage {

    dish_uid: string;
    dish: any = Array();
    valueChanges: any;
    dish_name: string;
    dish_price: number;
    colors: any;

    constructor(public navCtrl: NavController,
        public navParams: NavParams,
        public loadingCtrl: LoadingController,
        public globals: Globals,
        private alertCtrl: AlertController,
        public dishServices: DishServices,
        public uploadServices: Uploads,
        public printServices: PrintServices,
        public ingredientsServices: IngredientsServices,
        public staticsServices: StaticsServices,
        private http: HttpClient,
        public cp: CurrencyPipe,
        public translate: TranslateService,
        public configurationServices: ConfigurationServices,
        public toastCtrl: ToastController,) {
        this.colors = this.globals.getColorsElements();

    }

    ionViewWillEnter() {
        this.globals.GAtrackView('Dish', 'Dish - View', this.globals.restaurant.email, 'View', 'View dish', 'Dish', '');

        this.ingredientsServices.cleanArrayTmp(); // limpiamos array tmp de ingredientes

        this.dish_uid = this.navParams.get('dish_uid');
        this.dish_name = this.navParams.get('dish_name');
        this.dish_price = this.navParams.get('dish_price');

        this.dishServices.dishDoc = this.dishServices.afs.doc('dish/' + this.dish_uid); //Recuperamos el plato para tener el plato simpre actulizado.
        this.valueChanges = this.dishServices.dishDoc.valueChanges().subscribe(value => {
            var get_image = true;
            if (this.dish.image == value.image) {
                get_image = false;
            }
            value.UID = this.dish_uid; //Anadimos el UID al plato
            this.dish = value;
            this.dish_name = this.globals.nameLangSelectDish(this.dish);
            this.dish_price = this.dish.price;
            if (get_image) {
                this.getImageUrl(this.dish.image);//Get url from image
            }
            //ordenar tags
            value.tags = this.globals.orderNamesByAlphabetical(value.tags);
            //insert value a dish_tmp
            this.dishServices.dish_tmp = value;
        });


        this.stateDishStock();
        if (this.globals.checkLimitsByLicense('dishes', 'analitycs')) {
            this.getTotalDishSales();
            this.getTotalDishSalesLasts30days();
            this.getDishCostLastMonths();
        }
    }

    delete() {
        let alert = this.alertCtrl.create({
            title: this.translate.instant('instant-eliminar-plato'),
            message: this.translate.instant('instant-seguro-quieres-eliminar-plato'),
            buttons: [
                {
                    text: this.translate.instant('general-no'),
                    role: 'cancel',
                    handler: () => { }
                },
                {
                    text: this.translate.instant('general-si'),
                    handler: () => {
                        this.globals.GAtrackView('Dish', 'Dish - Delete', this.globals.restaurant.email, 'Delete', 'Delete dish', 'Dish', this.dish_name);

                        //
                        if (this.dishServices.filteredDishesActive) {
                            this.dishServices.filteredDishes.splice(this.dishServices.filteredDishes.findIndex(item => item.UID == this.dish_uid), 1);
                            this.dishServices.filteredDishes = [...this.dishServices.filteredDishes];
                        }
                        this.dishServices.dishes_array.splice(this.dishServices.dishes_array.findIndex(item => item.UID == this.dish_uid), 1);
                        this.dishServices.dishes_array = [...this.dishServices.dishes_array];
                        //
                        this.valueChanges.unsubscribe();
                        this.deletesAndStatics(this.dish_uid);
                        this.dishServices.delete(this.dish_uid);
                        this.redirect();


                    }
                }
            ]
        });
        alert.present();

    }
    async redirect() {
        let loadingPopup = this.loadingCtrl.create({
            spinner: 'crescent',
            content: ''
        });
        loadingPopup.present();
        await this.globals.delay(1000);
        this.navCtrl.pop();
        loadingPopup.dismiss();
    }

    async deletesAndStatics(uid) {
        this.staticsServices.changeStateStaticWait(true);
        this.staticsServices.addDeleteStaticToQueue(uid, 'deletes_dish_update');
    }

    getImageUrl(image_ref) {
        //Get image url for show. Lo utilitzamos en las classes de las views para utlitzarlas al momento ya que la funcion no tiene await.
        this.dishServices.image_url_dish_view = null;
        if (image_ref) {
            const ref = this.uploadServices.storage.ref(image_ref);
            this.dishServices.image_url_dish_view = ref.getDownloadURL();
        }

    }

    async print() {
        this.globals.GAtrackView('Dish', 'Dish - Full - Print', this.globals.restaurant.email, 'View', 'Print full', 'Dish', this.dish_name);

        if (this.globals.checkLimitsByLicense('dishes', 'print')) {//version pro abierto

            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: ''
            });
            loadingPopup.present();

            //Format values
            var dish_image;

            if (!this.dishServices.image_url_dish_view) {
                dish_image = '';
            } else {
                await this.dishServices.image_url_dish_view.subscribe(data => {
                    dish_image = data;
                });
            }

            var _currency = getCurrencySymbol(this.globals.user_currency, 'narrow', 'es');
            var currency = _currency;
            //Format object menu for POST send
            var dish_send = this.dishServices.dish_tmp;


            this.http.post(this.globals.api_path + 'dish/print',
                {
                    dish: dish_send,
                    dish_image: dish_image,
                    company: this.globals.restaurant.company,
                    currency: currency,
                    lang: this.globals.restaurant.lang,
                    show_image: this.globals.checkLimitsByLicense('dishes', 'image'),
                    prices3: this.globals.checkLimitsByLicense('dishes', '3prices'),
                    watermark: this.globals.checkLimitsByLicense('dishes', 'watermark'),
                    show_ingredients: this.globals.checkLimitsByLicense('dishes', 'foodcost'),
                    show_recipe: this.globals.checkLimitsByLicense('dishes', 'recipe'),
                    show_nutrition: this.globals.checkLimitsByLicense('dishes', 'nutrition'),
                    show_indicators: this.globals.checkLimitsByLicense('dishes', 'indicators'),
                }
                , {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    async print1() {

        this.globals.GAtrackView('Dish', 'Dish - Sheet - Print ', this.globals.restaurant.email, 'View', 'Print sheet', 'Dish', this.dish_name);

        if (this.globals.checkLimitsByLicense('dishes', 'print')) {//version pro abierto
            let loadingPopup = this.loadingCtrl.create({
                spinner: 'crescent',
                content: ''
            });
            loadingPopup.present();

            //Format values
            var dish_image;

            if (!this.dishServices.image_url_dish_view) {
                dish_image = '';
            } else {
                await this.dishServices.image_url_dish_view.subscribe(data => {
                    dish_image = data;
                });
            }

            //Format object menu for POST send
            var dish_send = this.dishServices.dish_tmp;

            this.http.post(this.globals.api_path + 'dish/print1',
                {
                    dish: dish_send,
                    dish_image: dish_image,
                    company: this.globals.restaurant.company,
                    lang: this.globals.restaurant.lang,
                    show_image: this.globals.checkLimitsByLicense('dishes', 'image'),
                    prices3: this.globals.checkLimitsByLicense('dishes', '3prices'),
                    watermark: this.globals.checkLimitsByLicense('dishes', 'watermark'),
                    show_ingredients: this.globals.checkLimitsByLicense('dishes', 'foodcost'),
                    show_recipe: this.globals.checkLimitsByLicense('dishes', 'recipe'),
                    show_nutrition: this.globals.checkLimitsByLicense('dishes', 'nutrition'),
                    show_indicators: this.globals.checkLimitsByLicense('dishes', 'indicators'),
                }, {})
                .subscribe(res => {
                    if (this.globals.so_mobile) {
                        window.location.assign(String(res['file']));
                    } else {
                        window.open(String(res['file']), '_blank');
                    }
                    loadingPopup.dismiss();
                }, error => {
                    loadingPopup.dismiss();
                });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    printEtiqueta() {
        if (this.globals.checkLimitsByLicense('dishes', 'print')) {
            this.navCtrl.push(DishViewLabelPage, {
                dish: this.dish
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    public list_state_dish_stock: any = [];
    public max_dish_create: any = 0;
    async stateDishStock() {
        this.list_state_dish_stock = [];
        var dish = await this.dishServices.getDish(this.dish_uid);
        var max_create = [];

        for (let foodcost of dish.foodcost) {
            var ing = await this.ingredientsServices.getIngredient(foodcost.uid);
            this.list_state_dish_stock.push({
                name: foodcost.name_static,
                stock: ing.stock,
                measurement: ing.measurement,
                UID: ing.UID
            });
            var ing_stock = this.globals.returnBigtoLittleMeasurement(ing.stock, ing.measurement);

            max_create.push(ing_stock / (foodcost.quantity_gross / dish.foodcost_parts));
            this.max_dish_create = Math.min.apply(null, max_create);
            this.max_dish_create = Math.trunc(this.max_dish_create);
        }
    }

    openProviderOrderAdd(element) {
        if (this.globals.checkLimitsByLicense('dishes', 'foodcost')) {
            if (this.dish.foodcost.length > 0) {
                this.navCtrl.push(ProviderOrderAddPage, {
                    element: element,
                    type: 'dish'
                });
            } else {
                let toast = this.toastCtrl.create({
                    message: this.translate.instant('dish-view-sin-escandallo-no-podemos-entregarte-datos'),
                    duration: 3000,
                    position: 'bottom'
                });
                toast.present();
            }
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }



    desactivateOfTpv() {
        if (this.globals.checkLimitsByLicense('dishes', 'activable_tpv')) {
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'tpv_active': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateOnTpv() {
        if (this.globals.checkLimitsByLicense('dishes', 'activable_tpv')) {
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'tpv_active': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    desactivateOfTk() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'tk_active': false,
            });
            //statics
            this.staticsServices.changeStateStaticWait(true);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateInTk() {
        if (this.globals.checkLimitsByLicense('menus', 'digital_menu')) {
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'tk_active': true,
            });
            //statics
            this.staticsServices.changeStateStaticWait(true);
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }

    }

    desactivateFavourite() {
        if (this.globals.checkLimitsByLicense('dishes', 'favourites')) {//version pro abierto
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'pos_favourite': false,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    activateFavourite() {
        if (this.globals.checkLimitsByLicense('dishes', 'favourites')) {//version pro abierto
            this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
                'pos_favourite': true,
            });
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    total_dish_sales: number = 0;
    total_dish_sales_billing: number = 0;
    getTotalDishSales() {
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.dish_name);
        this.http.post(this.globals.analytics_path + 'bidish/get_total_dish_sales', params, {})
            .subscribe(res => {
                this.total_dish_sales = res[0].total_dish_sales;
                const totalAmount = res && res[0] ? Number(res[0].total_amount || res[0].total_dish_sales_billing) : NaN;
                if (Number.isFinite(totalAmount)) {
                    this.total_dish_sales_billing = totalAmount;
                } else {
                    this.total_dish_sales_billing = 0;
                }
            });
    }

    total_dish_sales_lasts30_days: number = 0;
    total_dish_sales_billing_lasts30_days: number = 0;
    getTotalDishSalesLasts30days() {
        let last_date = moment().subtract(30, 'days').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.dish_name)
            .set('last_date', last_date);
        this.http.post(this.globals.analytics_path + 'bidish/get_total_dish_sales_lasts_30days', params, {})
            .subscribe(res => {
                this.total_dish_sales_lasts30_days = res[0].total_dish_sales_lasts_30days;
                const totalAmount = res && res[0]
                    ? Number(res[0].total_amount || res[0].total_dish_sales_billing_lasts_30days)
                    : NaN;
                if (Number.isFinite(totalAmount)) {
                    this.total_dish_sales_billing_lasts30_days = totalAmount;
                } else {
                    this.total_dish_sales_billing_lasts30_days = 0;
                }
            });
    }

    public _dish_cost_last_months: any = 0;
    public dish_cost_last_months: any = 0;
    public dish_cost_state = '';
    dish_cost_percent: any; //mostraremos el procentaje en la view
    async getDishCostLastMonths() {
        var dish = await this.dishServices.getDish(this.dish_uid);
        let last_date = moment().subtract(12, 'months').format("YYYY-MM-DD");
        const params = new HttpParams()
            .set('uid', this.globals.restaurant_uid)
            .set('dish_name', this.dish_name)
            .set('last_date', last_date);
        this.http.post(this.globals.analytics_path + 'bidish/get_dish_cost_last_months', params, {})
            .subscribe(res => {
                this._dish_cost_last_months = res[0].dish_cost_last_months;
                //Calculamos coste de los ultimos mesesx
                let _dish_foodcost = dish.foodcost_static / dish.foodcost_parts; // calculamos foodcost del dish

                this.dish_cost_percent = 100 - this.globals.regla3(this._dish_cost_last_months, _dish_foodcost); //REstamos sobre 100 por tener el porcentaje

                if (this._dish_cost_last_months > _dish_foodcost) {
                    this.dish_cost_state = 'positive';
                } else {
                    this.dish_cost_state = 'negative';
                    this.dish_cost_percent = Math.abs(this.dish_cost_percent);
                }
            });
    }

    // editFavVarations() {
    //     if (this.globals.checkLimitsByLicense('dishes', 'variations_favourites')) {//version pro abierto
    //         this.navCtrl.push(VariationsCreateFavSelectPage, {
    //             update: true,
    //             dish_uid: this.dish.UID,
    //             dish_name: this.globals.nameLangSelectDish(this.dish),
    //             fav_variations: this.dish.variations_favourite,
    //             origin: 'dish',
    //             dish: this.dish,

    //         })
    //     } else {
    //         this.navCtrl.push(AddonsTriggerVersionProPage);
    //     }
    // }
    
    editComplements() {
        if (this.globals.checkLimitsByLicense('dishes', 'variations_favourites')) {//version pro abierto
            this.navCtrl.push(VariationsCreateFavSelectPage, {
                update: true,
                dish_uid: this.dish.UID,
                dish_name: this.globals.nameLangSelectDish(this.dish),
                fav_variations: this.dish.variations_favourite,
                origin: 'dish',
                dish: this.dish,

            })
        } else {
            this.navCtrl.push(AddonsTriggerVersionProPage);
        }
    }

    openModalVersionPro() {
        this.navCtrl.push(AddonsTriggerVersionProPage);
    }

    updateIonToggle(value) {
        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'featured': value,
        });
    }

    setColor(color) {
        this.dishServices.afs.collection('dish').doc(this.dish_uid).update({
            'pos_background_color': color.pos_background_color,
            'pos_border_color': color.pos_border_color,
            'pos_color_name': color.name
        });
    }
    setBackgroundColor(dish) {
        return {
            'background-color': dish.pos_background_color,
            'border': '1px solid ' + dish.pos_border_color,
            'margin-left': '9px',
        }
    }

    openIngredientView(ingredient) {
        this.navCtrl.push(IngredientViewPage, {
            ingredient_uid: ingredient.UID,
            ingredient_name: ingredient.name
        });
    }

    editEan() {
        this.navCtrl.push(DishCreatePricePage, {
            update: true,
            dish_uid: this.dish.UID,
            price: this.dish.price,
            price_half: this.dish.price_half,
            price_tapa: this.dish.price_tapa,
            price_supplement: this.dish.price_supplement,
            price_combo_extra: this.dish.price_combo_extra,
            price_takeaway: this.dish.price_takeaway,
            dish_name: this.globals.nameLangSelectDish(this.dish),
            dish: this.dish,
            ean: this.dish.ean
        });
    }
}



// WEBPACK FOOTER //
// ./src/pages/dish/dish-view/dish-view/dish-view.ts